module.exports = __webpack_public_path__ + "static/media/icon-event__la-guerra-fria.6f32a7ee.svg";